import { TranslateFunc } from '@prisjakt/ui-translate/src/translate-func';
import { ClientMarket } from '@prisjakt/web-app-config/types/client-market';
import { PriceDisplay } from 'src/components/price-list/types';
import { Maybe, OfferPricePrice, OfferPrices, PricePrice } from 'src/types';
import { getDisplayPrice } from '../price-display';

export function getCompiledPriceData(
  price: PricePrice | null | undefined,
  offerPrice: OfferPrices | null | undefined,
  priceDisplay: PriceDisplay,
  featured: boolean,
  t: TranslateFunc,
  market: ClientMarket
) {
  if (!price) {
    return { label: null, mainPrice: null, secondaryPrice: null };
  }

  const pricesEqual = price?.exclShipping === offerPrice?.price?.exclShipping;

  const isMemberPrice =
    featured && pricesEqual ? Boolean(offerPrice?.memberPrice) : false;

  const isPromotion =
    featured && pricesEqual
      ? offerPrice?.price?.exclShipping !==
        offerPrice?.originalPrice?.exclShipping
      : false;

  const secondaryPrice =
    offerPrice?.originalPrice && isPromotion && !isMemberPrice
      ? getDisplayPrice(offerPrice.originalPrice, priceDisplay)
      : null;

  const hasPriceDate =
    featured && isPromotion && secondaryPrice && offerPrice?.price?.endDate;

  const promotionLabel =
    hasPriceDate && featured
      ? getPromotionLabel(offerPrice, market.localeStandard, t)
      : null;

  const memberLabel =
    isMemberPrice && featured
      ? getMemberLabel(offerPrice?.memberPrice, priceDisplay, t)
      : null;

  return {
    label: memberLabel || promotionLabel,
    mainPrice: getDisplayPrice(price, priceDisplay),
    secondaryPrice,
  };
}

export function getPromotionLabel(
  offerPrice: OfferPrices | null | undefined,
  locale: string,
  t: TranslateFunc
) {
  if (!offerPrice?.price?.endDate) {
    return null;
  }
  return `${t('product', 'promotions.exp-date-label')} ${new Date(
    Number(offerPrice!.price!.endDate!)
  ).toLocaleDateString(locale, { day: 'numeric', month: 'short' })}`;
}

export function getMemberLabel(
  price: Maybe<OfferPricePrice> | undefined,
  priceDisplay: PriceDisplay,
  t: TranslateFunc
) {
  const p = getDisplayPrice(price, priceDisplay);

  return `${t('product', 'promotions.members-price')} ${p}`;
}
